import {get} from './http';

export type CompiledPrompt = {
  name: string;
  version: number;
  labels: string[];
  prompt: string | Array<{role?: string; content?: unknown}>;
  config: Record<string, unknown> | null;
  variables: string[];
};

export const compiledPromptsApi = {
  list: async () => get<CompiledPrompt[]>('/admin/prompts')
};
